export default {
  title: 'Atualizar perfil de {{name}}',
  form: {
    name: {
      label: 'Nome',
      placeholder: 'Introduza o nome completo do proprietário',
    },
    email: {
      label: 'E-mail',
      placeholder: 'Introduza o e-mail pessoal do proprietário',
      tooltip: 'E-mail pessoal do proprietário/gestor do restaurante. Utilizado como login no painel',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
